import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchSuggestedData } from "./UAFetchSuggestedData";
import "../../Styles/UASuggestedContent.css";
import Carousel from "../../../../common/Carousel/Carousel";
import GridLayout from "../../../../common/Grid/gridMode";
import LightboxGallery from "../../../../common/LightBox/lightBox";
import HorizontalScrollDisplay from "../../../../common/HorizontalScroll/horizontalScroll";
import VerticalScroll from "../../../../common/VerticalScroll/verticalScroll";
import "../../../Styles/common-styles.css";

const UASuggestedContent = ({ mediaDisplayMode, userId }) => {
  const [suggestedData, setSuggestedData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSuggestedData().then((data) => {
      setSuggestedData(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="uasg-loading">
        <p className="text-header">Loading suggested posts...</p>
      </div>
    );
  }

  return (
    <div className="uasg-suggested-feed-container">
      {suggestedData && suggestedData.length > 0 ? (
        suggestedData.map((user) => (
          <div key={user.userId} className="uasg-user-section">
            {/* User Header - Black Background */}
            <div className="uasg-user-header-section">
              <div className="uasg-user-info-wrapper">
                <div className="uasg-user-avatar-wrapper">
                  <img
                    src={user.userimage}
                    alt="User"
                    className="tt-profile-image"
                  />
                </div>

                <div className="uasg-user-details">
                  <div className="uasg-user-name-row">
                    <Link
                      to={`/user-account/${user.userId}`}
                      className="uasg-user-name-link"
                    >
                      <span className="text-header">{user.userName}</span>
                    </Link>

                    {/* Highlighted Profile Badge */}
                    {user.profileId && (
                      <div className="uasg-profile-badge" style={{background: "rgba(36,36,45,0.2)", color: "white", border: "1px solid white"}}>
                        <Link
                          to={`/user-page/${userId}/${user.userId}/${user.profileId}`}
                          className="uasg-profile-link"
                          style={{color: "white"}}
                        >
                          #{user.profileId}
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* User's Posts */}
            <div className="uasg-posts-wrapper">
              {user.posts && user.posts.length > 0 ? (
                user.posts.map((post) => (
                  <div key={post.postId} className="uasg-post-wrapper">
                    <div>
                      {/* Post Header Section - Black Background */}
                      <div className="uasg-post-header-section" style={{display: "flex", flexDirection: "row"}}>
                        {/* Post ID */}
                        <div className="uasg-post-id">
                          <Link
                            to={`/post-page/${post.postId}`}
                            className="uasg-post-id-link"
                          >
                            Post: {post.postId}
                          </Link>
                        </div>
                      
                        <div>
                          {/* Suggested By - Blinking Arrow with Username */}
                          {post.sharedBy && (
                            <div className="uasg-suggested-by-wrapper">
                              <span className="uasg-blinking-arrow" style={{color: "white"}}>←</span>
                              <span className="uasg-suggested-by-text">
                                Suggested by{" "}
                                <Link
                                  to={`/user-account/${post.sharedBy.userId || post.sharedBy}`}
                                  className="uasg-suggested-by-link"
                                  style={{color: "gray"}}
                                >
                                  {post.sharedBy.userName || post.sharedBy}
                                </Link>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Timestamp on Next Line */}
                      <div className="uasg-timestamp-row">
                        <span className="text-label uasg-timestamp" style={{marginLeft: 15}}>
                          {new Date(post.timestamp).toLocaleString()}
                        </span>
                      </div>
                    </div>

                    {/* Post Card - Content Only */}
                    <div className="uasg-suggested-feed-card">
                      {/* Description */}
                      <div className="uasg-post-description">
                        <p className="text-label">{post.descriptions}</p>
                      </div>

                      {/* Media Content */}
                      {Array.isArray(post.medias) && post.medias.length > 0 && (
                        <div className="uasg-suggested-feed-media">
                          <div className="uasg-suggested-media-container">
                            {mediaDisplayMode === "slideshow" ? (
                              <Carousel items={post.medias} />
                            ) : mediaDisplayMode === "lightbox" ? (
                              <LightboxGallery mediaFiles={post.medias} />
                            ) : mediaDisplayMode === "horizontal-scroll" ? (
                              <HorizontalScrollDisplay medias={post.medias} />
                            ) : mediaDisplayMode === "vertical-scroll" ? (
                              <VerticalScroll medias={post.medias} />
                            ) : (
                              <GridLayout mediaFiles={post.medias} />
                            )}
                          </div>
                        </div>
                      )}

                      {/* Location Footer */}
                      <div className="uasg-post-location">
                        <Link
                          to={`/location-page/${post.location}`}
                          className="uasg-location-link"
                          style={{color: "white"}}
                        >
                          {post.location}
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="uasg-no-posts">
                  <p className="text-label">No posts available.</p>
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="uasg-no-suggestions">
          <p className="text-label">No suggested content found.</p>
        </div>
      )}
    </div>
  );
};

export default UASuggestedContent;
